import { Fragment, useCallback } from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import InfluencerIdentityRowPerformanceEstimatedCPEAverageTooltip from '@components/Inbox/InfluencerIdentity/Row/Performance/EstimatedCPE/Tooltip/AverageTooltip'
import Loading from '@components/UI/Loading'
import { NoticeEmpty } from '@components/UI/Notice'
import { SupportedScreenWrapper } from '@components/UI/ScreenSize'
import hooks from '@hooks'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectIsCampaignFetched } from '@store/campaigns'
import {
  fetchInfluencerIdentities,
  selectHasInfluencerIdentities,
  selectInfluencerIdentitiesIsInitialFetch,
} from '@store/influencerIdentities'
import InfluencerIdentityLayoutUnsupportedScreen from '../Layout/UnsupportedScreen'
import InfluencerIdentityList from './List'

const UnsupportedScreenHandler = ({ children }) => (
  <Fragment>
    <InfluencerIdentityLayoutUnsupportedScreen />
    <SupportedScreenWrapper>{children}</SupportedScreenWrapper>
  </Fragment>
)

export const InfluencerIdentityListWrapper = () => {
  const dispatch = useDispatch()
  const campaignId = useCampaignIdFromRoute() as number

  const isCampaignFetched = useSelector((state: IApplicationState) =>
    selectIsCampaignFetched(state, campaignId),
  )
  const isInitialFetch = useSelector((state: IApplicationState) =>
    selectInfluencerIdentitiesIsInitialFetch(state, campaignId),
  )
  const hasInfluencerIdentities = useSelector((state: IApplicationState) =>
    selectHasInfluencerIdentities(state, campaignId),
  )

  const search = hooks.useLocationSearch()

  const fetchInfluencerIdentitiesAction = useCallback(
    (id: number) => dispatch(fetchInfluencerIdentities(id)),
    [dispatch],
  )

  hooks.useActionDispatcherEffect(
    true,
    fetchInfluencerIdentitiesAction,
    [campaignId],
    [isCampaignFetched],
  )

  const shouldFetchAndResetList = !isInitialFetch && Boolean(search.sort_by)
  hooks.useActionDispatcherEffect(
    shouldFetchAndResetList,
    fetchInfluencerIdentitiesAction,
    [campaignId],
    [search.sort_by],
  )

  if (isInitialFetch || !isCampaignFetched) {
    return <Loading />
  }

  if (!hasInfluencerIdentities) {
    return (
      <UnsupportedScreenHandler>
        <NoticeEmpty
          alt="influencer-identities-submissions"
          title={<FormattedMessage id={`inbox.cardlist.empty.title.inbox`} />}
          subtitle={<FormattedMessage id={`inbox.cardlist.empty.subtitle.inbox`} />}
        />
      </UnsupportedScreenHandler>
    )
  }

  return (
    <UnsupportedScreenHandler>
      <InfluencerIdentityList />
      <InfluencerIdentityRowPerformanceEstimatedCPEAverageTooltip />
    </UnsupportedScreenHandler>
  )
}

export default InfluencerIdentityListWrapper
